<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Update item'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Name'|translate}}</mat-label>
                    <input matInput formControlName="name" required>
                    <mat-error>{{'Name is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Alt name'|translate}}</mat-label>
                    <input matInput formControlName="name">
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Order'|translate}}</mat-label>
                    <input matInput formControlName="order">
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="backgroundImage" fxFlex="100">
                    <mat-label>{{'Is background'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="fillImage" fxFlex="100">
                    <mat-label>{{'Is fill'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="imageForRecommendedPage" fxFlex="100">
                    <mat-label>{{'Image for recommended page'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="imageForTheNewestPage" fxFlex="100">
                    <mat-label>{{'Image for the newest page'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="imageForCategoryPage" fxFlex="100">
                    <mat-label>{{'Image for the category page'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="imageForVouchersListPage" fxFlex="100">
                    <mat-label>{{'Image for vouchers list page'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="imageForDetailsPage" fxFlex="100">
                    <mat-label>{{'Image for details page'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="imageForBasketPage" fxFlex="100">
                    <mat-label>{{'Image for basket page'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="80">
                    <mat-label>{{'Destination'|translate}}</mat-label>
                    <mat-select formControlName="destination">
                        <mat-option [value]="destination.id" *ngFor="let destination of destinations">
                            {{destination.name|translate}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Page'|translate}}</mat-label>
                    <input type="text"
                           placeholder="{{ 'Page'|translate }}"
                           matInput
                           formControlName="page"
                           [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option [value]="page" *ngFor="let page of filteredPages|async">
                            {{page.languages[0].name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error>{{'Page is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="deleteImage()"
                color="warn"
                [disabled]="processing"
                aria-label="Cancel">
            {{'Delete'|translate}}
        </button>
        <button
                mat-button
                class="save-button"
                (click)="matDialogRef.close(form)"
                [disabled]="form.invalid || processing"
                aria-label="Save">
            {{'Save'|translate}}
        </button>

    </div>
</div>
